import { UpdateSignedOrderParams } from 'api/types/params';
import { lodash } from 'helpers';
import { YesOrNoType } from 'types/yesOrNo';

import { OrderFormType } from '../forms/orderForm';

export const getSignedOrderSubmitData = (
  values: OrderFormType
): UpdateSignedOrderParams => ({
  fmNumber: values.fmNumber,
  marketType: values.marketType?.value,
  assignedEmployeeId: values.manager?.id ?? null,
  transactionVenue: values.transactionVenue?.value,
  settlementCondition: values.settlementCondition?.value,
  hasBrokerRecommendation: values.hasBrokerRecommendation
    ? values.hasBrokerRecommendation?.value === YesOrNoType.Yes
    : null,
  comment: values.comment,
  adminFileIds: lodash.compact(values.adminDocuments?.map((file) => file.id)),
});
